import styled from "styled-components";
import { lazy, Suspense, useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from 'axios'

import cat from "../assets/Images/cat01_sit_8fps.gif"
import dog from "../assets/Images/dog_sit_12fps.gif"

import Loading from "../subComponents/Loading";

const PowerButton = lazy(() => import("../subComponents/PowerButton"));
const LogoComponent = lazy(() => import("../subComponents/LogoComponent"));

const MainContainer = styled(motion.div)`
`;

const Container = styled.div`
  background-color: ${(props) => `rgba(${props.theme.bodyRgba},0.8)`};
  width: 100%;
  height: auto;
  position: relative;
  padding-bottom: 100vh;
  overflow: hidden;
`;

const CoolButton = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2rem;
right: 5vw;
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 24px;
width: auto;
text-align: right;

@media only screen and (max-width: 51.75em) {
  top: 10%;
  left: 2vw;
}
@media only screen and (max-width: 30em) {
  top: 10%;
  left: 2vw;
}
`

const CoolButton2 = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2rem;
right: 90vw;
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 24px;
width: auto;
text-align: left;

@media only screen and (max-width: 51.75em) {
  top: 60%;
  left: 2vw;
}
@media only screen and (max-width: 30em) {
  top: 60%;
  left: 2vw;
}
`

const Fact = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2.8rem;
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 16px;
font-weight: normal;
max-width: 96vw;
right: 0;
text-align: right;

@media only screen and (max-width: 51.75em) {
    width: 96vw;
    right: 0vw;
    height: ${(props) => (props.click ? "80px" : "100px")};
}
@media only screen and (max-width: 30em) {
    width: 95vw;
    right: 0vw;
    height: ${(props) => (props.click ? "40px" : "100px")};
}
`

const DogFact = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2.8rem;
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 16px;
font-weight: normal;
max-width: 96vw;
right: 0;
text-align: left;

@media only screen and (max-width: 51.75em) {
  top: 100%;
  left: 2vw;
  padding-right: 2vw;
  width: 95vw;
  height: ${(props) => (props.click ? "80px" : "100px")};
}
@media only screen and (max-width: 30em) {
  top: 100%;
  left: 2vw;
  padding-right: 2vw;
  width: 95vw;
  height: ${(props) => (props.click ? "80px" : "100px")};
}
`

const Center = styled.button`
position: absolute;
top: 50vh;
left: 50%;
transform: translate(-50%, -50%);
border: none;
padding: 5px;
outline: solid 2px rgba(0, 0, 0, 1);
background-color: transparent;
cursor: pointer;
font-family: 'Ubuntu Mono', monospace;
font-size: 24px;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
}
`

const Cat = styled.div`
position: absolute;
bottom: 7%;
right: 95%;
width:32px;
transform: scale(8);
image-rendering: pixelated;

@media only screen and (max-width: 51.75em) {
    width: 16px;
    transform: scale(4);
    bottom: 3%;
}
@media only screen and (max-width: 30em) {
    width: 16px;
    transform: scale(4);
    bottom: 3%;
}
`

const Dog = styled.div`
position: absolute;
bottom: 14vh;
right: 5%;
width:32px;
transform: scale(8) rotateY(180deg);
image-rendering: pixelated;

@media only screen and (max-width: 51.75em) {
    display: none;
}
@media only screen and (max-width: 30em) {
    display: none;
}
`

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const BlogPage = () => {
  
  const [fact, setFact] = useState("");
  const [dogFact, setDogFact] = useState("");
  const [click, setClick] = useState();
  
  const factClick = () => {
    axios.get('https://meowfacts.herokuapp.com/').then(res => {
    console.log(res.data)
    setFact(res.data.data)
    }).catch((e) => {
        console.log(e)
      })
  }

  
  const dogFactClick = () => {
    axios.get('https://dog-facts-api.herokuapp.com/api/v1/resources/dogs?number=1').then(res => {
    console.log(res.data[0].fact)
    setDogFact(res.data[0].fact)
    }).catch((e) => {
        console.log(e)
      })
  }

  const handleClick = () => setClick(!click)

  return (
    <Suspense fallback={<Loading />}>
      <MainContainer
        variants={container}
        initial="hidden"
        animate="show"
        exit={{ opacity: 0, transition: { duration: 0.5 } }}
      >
        <Container>
          <PowerButton />
          <CoolButton onClick={() => factClick()}>
            <motion.h3
            initial={{
                y: -200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            >
            Cat Fact
            <Fact>{fact}</Fact>
            </motion.h3>
          </CoolButton>
          <CoolButton2 onClick={() => dogFactClick()}>
            <motion.h3
            initial={{
                y: -200,
                transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            animate={{
                y: 0,
                transition: { type: "spring", duration: 1.5, delay: 1 },
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            >
            Dog Fact
            <DogFact>{dogFact}</DogFact>
            </motion.h3>
          </CoolButton2>
          <Center>
          <span>
          Game Demo Coming Soon
          </span>
          </Center>
          <Cat onClick={() => handleClick()}>
          <img src={cat}></img>
          </Cat>
          <Dog>
          <img src={dog}></img>
          </Dog>
        </Container>
      </MainContainer>
    </Suspense>
  );
};

export default BlogPage;
